export default "__VITE_ASSET__00c92e78__"